import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Track if a toast is currently visible
let isToastVisible = false;

/**
 * Show a toast message
 * @param {Object} options
 * @param {"success"|"error"|"info"|"warn"} options.type
 * @param {string} options.message
 */
const RenderToast = ({ type = "info", message = "" }) => {
  if (!message || isToastVisible) return;

  isToastVisible = true;

  const config = {
    autoClose: 3000,
    onClose: () => (isToastVisible = false),
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  };

  switch (type) {
    case "success":
      toast.success(message, config);
      break;
    case "error":
      toast.error(message, config);
      break;
    case "warn":
      toast.warn(message, config);
      break;
    default:
      toast.info(message, config);
      break;
  }
};

export const ToastHost = () => (
  <ToastContainer
    position="top-right"
    autoClose={2500}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    theme="colored"
  />
);

export default RenderToast;
